'use client';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { fadeIn } from '@/lib/animations';
import { History as HistoryIcon, Box, Award } from 'lucide-react';
import { TextImageSection } from '@/components/TextImageSection';

export function History() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.05,
    rootMargin: '200px 0px',
  });

  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          ref={ref}
          initial="hidden"
          animate={inView ? "show" : "hidden"}
          variants={fadeIn('up')}
          className="text-center mb-16"
        >
          <h2 className="text-sm font-semibold text-brand-600 uppercase tracking-wider mb-2">Our Legacy</h2>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Three Decades of Excellence
          </h3>
        </motion.div>
      </div>

      <TextImageSection
        title=""
        content={
          <>
            <p>
              What began as a small operation hauling butter in refrigerated trucks has evolved into the state's only third-party logistics (3PL) provider operating within a Foreign-Trade Zone (FTZ).
            </p>
            
            <p>
              Today, Lindner Logistics offers comprehensive warehousing and distribution services, specializing in multi-temperature and dry goods storage. Our commitment to innovation, customer care, and operational excellence has earned us recognition as a top 3PL and cold storage provider by Food Logistics.
            </p>

            <p>
              As we celebrate our 30th anniversary, we remain dedicated to going the extra mile for our clients, ensuring their supply chains are efficient, compliant, and cost-effective.
            </p>

            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto bg-brand-100 rounded-lg flex items-center justify-center text-brand-600 mb-3">
                  <HistoryIcon size={32} />
                </div>
                <p className="font-semibold text-gray-900">Since 1994</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 mx-auto bg-brand-100 rounded-lg flex items-center justify-center text-brand-600 mb-3">
                  <Award size={32} />
                </div>
                <p className="font-semibold text-gray-900">Top 3PL Provider</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 mx-auto bg-brand-100 rounded-lg flex items-center justify-center text-brand-600 mb-3">
                  <Box size={32} />
                </div>
                <p className="font-semibold text-gray-900">FTZ Certified</p>
              </div>
            </div>
          </>
        }
        imageUrl="https://lindner-marketing.s3.eu-west-2.amazonaws.com/lindner-sign-picture-30-years.webp"
        imageAlt="Lindner Logistics History"
        backgroundColor="bg-gray-50"
        sectionClassName="!pt-0"
      />
    </section>
  );
}